export const MENU_VIEW_ELEMENT = {
  sort_stock_menu: 'across_first'
}
